export function stepsProgress() {
    const $window = $(window);
    const timeline = $(".section-difference .steps-list");
    const timelineItems = timeline.find(".item");
    let $windowWidth = $window.width();
    let $windowHeight = $window.height();
    let scrollTop;
    let resizeTimeout;

    function timeLineAnimate() {
        $windowHeight = $window.height();
        timelineItems.each(function () {
            const $this = $(this);
            const itemHeight = $this.outerHeight(true);
            const itemOffsetTop = $this.offset().top;
            $this.attr("data-height", itemHeight);
            $this.attr("data-offset-top", itemOffsetTop);
            if ((scrollTop + $windowHeight / 2 >= itemOffsetTop)) {
                if (!$this.hasClass('active')) {
                    $this.addClass('active');
                }
            } else {
                $this.removeClass('active');
            }
        })
    }

    $window.on("scroll load", function () {
        scrollTop = $(document).scrollTop();
        timeLineAnimate();
    });

    $window.on("resize", function () {
        $windowWidth = $window.width();
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(() => {
            timeLineAnimate();
        }, 100)
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stepsProgress.js